import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EditWindowDetailsComponent } from '../edit-window-details/edit-window-details.component';
import * as Constants from "../../utils/Constants";
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-edit-window-type',
  templateUrl: './edit-window-type.component.html',
  styleUrls: ['./edit-window-type.component.scss'],
  standalone: false,
})
export class EditWindowTypeComponent implements OnInit {
  selectedOption: any;
  listData: any = Constants.data_windows.filter(
    (item: any) => item.id !== 13 && item.id !== 14
  );
  @Input() isComparisonMode: boolean = false;

  constructor(private modalController: ModalController, private storageService: StorageService) { }

  ngOnInit() {
  }
  ionViewWillEnter() {
    this.init();
  }

  async init() {
    // Load existing values if available
    const res = this.isComparisonMode
      ? await this.storageService.getComparedProject()
      : await this.storageService.getProject();
    let storedProject = res ? JSON.parse(res) : null;
    console.log(storedProject?.windowtype)
    if (storedProject?.windowtype) {
      this.selectedOption = Constants.data_windows.find(
        (w: any) => w.id === storedProject.windowtype
      ) ?? null;
    }
    console.log(`${this.isComparisonMode ? 'Compared' : 'Main'} windowtype:`, this.selectedOption);
  }

  selectOption(option: any) {
    this.selectedOption = option;
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }

  async next() {
    if (this.selectedOption) {
      // this.modalController.dismiss({
      //   selectedOption: this.selectedOption
      // }, 'confirm');

      const modal = await this.modalController.create({
        component: EditWindowDetailsComponent,
        cssClass: 'configuration-modal',
        componentProps: {
          selectedWindowType: this.selectedOption,
          isComparisonMode: this.isComparisonMode
        }
      });

      await modal.present();

      const { data, role } = await modal.onWillDismiss();

      if (role === 'confirm') {
        console.log('Selected option:', data.selectedOption);
        await modal.dismiss();
        await this.modalController.dismiss(data, 'confirm');
      }
    }
  }

  dismiss() {
    console.log("dismiss called ")
    this.modalController.dismiss(null, 'dismiss');
  }

}
